import React from 'react';
import { ResponsiveTokenSet } from '../../theme/tokens/types';

import { ITeenReferralsHeroFields } from '../../../types/contentful';

import CtaWidget from '../CtaWidget';
import classNames from 'classnames';
import PrivacyPolicyDisclaimer from '~/components/PrivacyPolicyDisclaimer';
import { usePageDataContext } from '~/context/PageData';

interface Props extends ITeenReferralsHeroFields {
  yMarginTopOverride?: ResponsiveTokenSet<string>;
  yMarginBottomOverride?: ResponsiveTokenSet<string>;
}

export function TeenReferralsHero({
  headingText,
  heroCopy,
  privacyPolicyDisclaimer,
  ctaWidget,
  yMarginTopOverride,
  yMarginBottomOverride
}: Props) {
  const { teenReferralData } = usePageDataContext();
  return (
    <section
      className={classNames('block-container', {
        [`mt-${yMarginTopOverride?.[0]}`]: yMarginTopOverride?.[0],
        [`mobile:mt-${yMarginTopOverride?.mobile}`]: yMarginTopOverride?.mobile,
        [`tablet:mt-${yMarginTopOverride?.tablet}`]: yMarginTopOverride?.tablet,
        [`desktop:mt-${yMarginTopOverride?.desktop}`]:
          yMarginTopOverride?.desktop,
        [`mb-${yMarginBottomOverride?.[0]}`]: yMarginBottomOverride?.[0],
        [`mobile:mb-${yMarginBottomOverride?.mobile}`]:
          yMarginBottomOverride?.mobile,
        [`tablet:mb-${yMarginBottomOverride?.tablet}`]:
          yMarginBottomOverride?.tablet,
        [`desktop:mb-${yMarginBottomOverride?.desktop}`]:
          yMarginBottomOverride?.desktop
      })}
      data-blockid="text-only-hero"
      data-testid="text-only-hero"
      data-e2e="hero"
    >
      <div className="mx-auto flex max-w-max flex-col items-center justify-center gap-6 px-6 py-12">
        <div className="mx-auto flex w-full flex-col items-center gap-4 self-stretch desktop:w-8/12">
          <h1 className="typography-display-1 text-center font-normal">
            {headingText?.replace(
              '[kid]',
              teenReferralData?.name || 'Your child'
            )}
          </h1>
        </div>
        {heroCopy && (
          <h3 className="typography-display-4 text-center font-normal">
            {heroCopy}
          </h3>
        )}
        {ctaWidget && <CtaWidget {...ctaWidget.fields} className="w-full" />}
        {privacyPolicyDisclaimer && (
          <div className="box-border">
            <PrivacyPolicyDisclaimer
              privacyPolicyDisclaimer={privacyPolicyDisclaimer}
              displayPrivacyPolicyIcon={false}
              centerAlignTablet={true}
            />
          </div>
        )}
      </div>
    </section>
  );
}
